module.exports = __webpack_public_path__ + "static/img/service-01.795a4b37.png";